var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('sr-header',{on:{"changeNav":_vm.changeNav}}),_c('sr-sider',{ref:"srSider",staticClass:"sidebar-container"}),_c('el-container',[_c('el-main',{staticClass:"main-container"},[_c('sr-main')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }